import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_close",
  "use": "icon-ic_close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_close\">\n<path d=\"M12 10.5862L18.3639 4.22217L19.7781 5.63638L13.4142 12.0004L19.7781 18.3643L18.3639 19.7785L12 13.4146L5.63601 19.7785L4.2218 18.3643L10.5858 12.0004L4.2218 5.63638L5.63601 4.22217L12 10.5862Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol